import Backbone from 'backbone';
import { cookiesHostname, cookiesPath, isMobile, pathname } from '../others/Configuration';
import Cookies from 'js-cookie';
import $ from 'jquery';
import SharedDispatcher from '../others/SharedDispatcher';

import 'component?js-moreContentNav';
import 'component?js-CategoryNav';

/**
 * NavView includes Nav toggling components.
 * It is attached to body html element.
 */
export default Backbone.View.extend({
  initialize: function () {
    this.detect_scroll = this.detect_scroll.bind(this);

    this.$main = $('.Main');
    this.$header = $('.js-Header');
    this.$sidebar = $('.js-Sidebar');
    this.$slidenav = $('.SlideNav');
    this.$slidenavToggler = $('.js-SlideNav-toggler');
    this.isMenuLoaded = false;
    this.isSlideNavFixed = false;
    this.isSlideNavOpen = false;
    this.isSideBarOpen = false;
    this.position = null;

    $(window).scroll(this.detect_scroll);

    this.updateSidebarPosition();
    this.checkTopBar();
  },

  events: {
    'click .js-SlideNav-toggler': 'slideNavToggle',
    'click .js-Main-exitSlideNav': 'slideNavToggle',
    'click .js-submenu-toggler': 'sidebarToggle',
    'click .js-Main-exitSideBar': 'sidebarToggle',
    'touchstart .js-Main-exitSideBar': 'sidebarToggle',
    'click .js-category-toggler': 'categoryToggle',
    'click .js-TopBar-close': 'topBarClose',
  },

  checkTopBar: function () {
    if ($('.TopBar').length && Cookies.get('FnacKoboOrange_push') === 'isActive') {
      $('body').addClass('TopBar-spacer');
      $('.TopBar').show();
    }
  },

  //Close TopBar & set Cookie
  topBarClose: function () {
    Cookies.set('FnacKoboOrange_push', 'isActive', { expires: 30 * 3, path: cookiesPath, domain: cookiesHostname });
    $('body').removeClass('TopBar-spacer');
    $('.TopBar').hide();
  },

  updateSidebarPosition: function () {
    if (this.$sidebar.length) {
      this.isSlideNavFixed = true;
      //$(".SlideNav-toggler").addClass("isFixed");
    }
  },

  detect_scroll: function () {
    if (!isMobile) {
      var body = $('body');
      // check if function is defined for ie9 & ie10
      if (typeof $('.Sidebar-nano').nanoScroller === 'function') {
        $('.Sidebar-nano').nanoScroller({ scrollTop: body.scrollTop() });
      }
    }
  },

  /**
   *       _     _      _
   *      (_)   | |    | |
   *   ___ _  __| | ___| |__   __ _ _ __
   *  / __| |/ _` |/ _ \ '_ \ / _` | '__|
   *  \__ \ | (_| |  __/ |_) | (_| | |
   *  |___/_|\__,_|\___|_.__/ \__,_|_|
   *
   * Display or hide left menu with slide effect on mobile / tablet
   *
   */
  sidebarToggle: function () {
    if (this.isSideBarOpen) {
      this.isSideBarOpen = false;
      this.hideSideBar();
    } else {
      this.showSidebar();
      this.isSideBarOpen = true;
    }
  },

  hideSideBar: function () {
    $('.Main-exitMenu').removeClass('isActive');
    this.$sidebar.removeClass('isActive');
    this.$header.removeClass('isActive--inverse');
    this.$main.removeClass('isActive--inverse');
  },

  showSidebar: function () {
    $('.js-Main-exitSideBar').addClass('isActive');
    this.$sidebar.addClass('isActive');
    this.$header.addClass('isActive--inverse');
    this.$main.addClass('isActive--inverse');
    $('.js-Main-exitSideBar').addClass('isActive');
  },

  /**
   *
   *        _ _     _
   *       | (_)   | |
   *    ___| |_  __| | ___ _ __   __ ___   __
   *   / __| | |/ _` |/ _ \ '_ \ / _` \ \ / /
   *   \__ \ | | (_| |  __/ | | | (_| |\ V /
   *   |___/_|_|\__,_|\___|_| |_|\__,_| \_/
   *
   * Display or hide right menu on small tablet & mobile
   *
   */
  slideNavToggle: function (e) {
    e.preventDefault();

    // check if sidebar is open
    if (this.isSlideNavOpen) {
      this.isSlideNavOpen = false;
      this.hideSlideNav();
    } else {
      this.isSlideNavOpen = true;
    }
  },

  hideSlideNav: function () {
    $('.Main-exitMenu').removeClass('isActive');
    this.$slidenav.removeClass('isActive');
    this.$header.removeClass('isActive');
    this.$main.removeClass('isActive');
    this.$slidenavToggler.removeClass('isActive isFixed');
    this.$sidebar.removeClass('isFixed');
    SharedDispatcher.trigger('categorynav:removepanel');
  },

  showSlideNav: function () {
    $('.js-Main-exitSlideNav').addClass('isActive');
    this.$slidenav.addClass('isActive');
    this.$header.addClass('isActive');
    this.$main.addClass('isActive');
    this.$slidenavToggler.addClass('isActive isFixed');
    this.$sidebar.addClass('isFixed');
    SharedDispatcher.trigger('header-tab:close');
    $('.js-Main-exitSlideNav').addClass('isActive');
  },

  categoryToggle: function (event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    // check if function is defined for ie9 & ie10
    if (typeof $('.nano').nanoScroller === 'function') {
      $('.nano').nanoScroller();
    }
    var state = $(event.currentTarget).parent().hasClass('isClose');
    var $currentList = $(event.currentTarget).parent();
    if (state) {
      $currentList.removeClass('isClose');
    } else {
      $currentList.addClass('isClose');
    }
  },
});
